export default __webpack_public_path__ + "static/media/three-brex.5e909c71.png";